import React, { useEffect, useState, useCallback } from "react";
import {
  getRequestInAssets as getRequestOnEnterprise,
  deleteRequestInAssets,
} from "services/axiosAssetsBaseClient";
import TableAndSearch from "../common/TableAndSearch";
import { useHistory, Link } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import LocalStorageService from "services/tokenlocalstorage.service";
import QRCodeView from "../../components/QRcode/QRCode";
import ConfirmationDialog from "../common/ConfirmDialog";

var tempSearch;
var tableSearchKey;
export default function SwapStationList(props) {
  const { headerFilter } = props;

  const history = useHistory();

  const [swapStationsData, setSwapStationsData] = useState([]);
  const [siteStatus, setSiteStatus] = useState(true);
  const [activepageCount, setActivePageCount] = useState(0);
  const [search, setSearch] = useState("");
  const [tempSwap, setTempSwap] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
 
  const paginationCountHanlde = (count) => {
    setActivePageCount(count);
  };

  const getSwapStationsList = (searchString) => {
    if (
      typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
    ) {
    } else {
      localStorage.setItem("lastTableSearch", searchString);
    }

    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));

    var query =
      // (headerFilterObj?.enterprise
      //   ? "enterprise=" + headerFilterObj.enterprise
      //   : "") +

      (headerFilterObj?.stateId ? "&stateId=" + headerFilterObj?.stateId : "") +
      (headerFilterObj?.cityId ? "&cityId=" + headerFilterObj?.cityId : "") +
      (headerFilterObj?.zoneId ? "&zoneId=" + headerFilterObj?.zoneId : "") +
      (typeof searchString === "object" ||
      typeof searchString === "undefined" ||
      (typeof searchString === "string" && searchString?.trim().length === 0)
        ? ""
        : "&name=" + encodeURIComponent(searchString));
    query = query ? "?" + query : "";

    try {
      getRequestOnEnterprise("bss/swappingStation/getswapStationInfo" + query)
        .then((resp) => {
          if (resp?.data && resp.data?.swapStationList) {
            setSwapStationsData(resp?.data?.swapStationList);
            // props.assetCount(() => resp?.data?.count);
            props.assetCount(() => resp?.data?.swapStationList.length);
            setTotalCount(resp?.data?.swapStationList.length);
          }
        })
        .catch((e) => {
          console.log(e, "ERROR");
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    tempSearch = localStorage.getItem("lastTableSearch");
    if (headerFilterObj && Object.keys(headerFilterObj).length > 0) {
      getSwapStationsList(tempSearch);
    }
    if (headerFilterObj && !headerFilterObj) {
      headerFilter = false;
      setSwapStationsData([]);
      getSwapStationsList(tempSearch);
      // searchingByName();
    }
    // props.assetCount(()=>0);
    // getSwapStationsList();
  }, [headerFilter]);

  useEffect(() => {
    tempSearch = localStorage.getItem("lastTableSearch");
    if (tempSearch === null) {
      tempSearch = localStorage.setItem("lastTableSearch", "");
      getSwapStationsList();
    } else {
      getSwapStationsList(tempSearch);
    }

    // props.assetCount(() => 0);
    // getZoneData();
    window.scrollTo(0, 0);
  }, []);

  const viewSwapStation = (id, enterprise) => {
    history.push("/Assets/SwapStation/" + id + "/view");
  };

  const updateSwapStation = (id, enterprise) => {
    history.push("/Assets/updateSwapStation/" + id);
  };

  const statusActive = useCallback(async (data) => {
    if (data.isActive) {
      // setSiteStatus(false);
    } else {
      // setSiteStatus(true);
    }
    await getRequestOnEnterprise(
      `bss/changeStatusSwapStation?isActive=${!data.isActive}&swapStationId=${
        data.swapStationId
      }&enterprise=${data.enterprise}`
    )
      .then((res) => {
        if (res.data != null) {
          // getSwapStationsList();
          swapStationsData.filter((swapElement) => {
            if (swapElement.swapStationId == res.data.id) {
              console.log(swapElement, "INNER");
              swapElement.swapStationStatus = res.data.status;
              swapElement.isActive = res.data.isActive;
            }
          });
          setTempSwap(res.data);
          NotificationManager.success(res?.message);
          // setSiteData(res?.data);
          // props.assetCount(()=>res.data.length);
        }
      })
      .catch((err) => {
        NotificationManager.error(err.message);
        console.error("Error", err);
      });
  });

  const siteStatusHandle = (rowData, status, enterpriseName) => {
    statusActive(rowData.row.original, enterpriseName);
  };

  function deleteCheckBoxData(selectedRows) {
    deleteSwapStationHandle(selectedRows);
  }
  const deleteSwapStationHandle = useCallback(async (data) => {
    const ids = data.map(item => item.swapStationId); // Extracting swapStationId from each object
    await deleteRequestInAssets(
      `bss/swappingStation/softDeleteSwappingStation?ids=${ids.join(',')}`
    ).then((res) => {
      if (res && res?.data) {
        NotificationManager.success(res?.data.message);
        getSwapStationsList();
      }
    });
  });
  const columns = React.useMemo(
    () => [
      {
        Header: "Zone Name",
        accessor: "zoneName",
      },
      {
        Header: "Site Name",
        accessor: "siteName",
      },
      {
        Header: "Site Status",
        accessor: "siteStationStatus",
      },
      {
        Header: "Swap Stations",
        accessor: "swapStationName",
      },
      {
        Header: "QR Code",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <QRCodeView
                value={row.row.original.swapStationId.toString()}
                visibility={false}
              />
            </>
          );
        },
      },
      {
        Header: "Swap Station Status",
        accessor: "swapStationStatus",
        Cell: (row) => {
          return (
            <>
              {row.row.original.swapStationStatus === "HEALTHY" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "#1A873C",
                    border: "1px",
                    width: "180px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Healthy</span>
                </p>
              ) : row.row.original.swapStationStatus === "OFFLINE" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "#0049b0",
                    border: "1px",
                    width: "180px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Offline</span>
                </p>
              ) : row.row.original.swapStationStatus === "UNDERMAINTENANCE" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "orange",
                    border: "1px",
                    width: "180px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Under Maintenance</span>
                </p>
              ) : row.row.original.swapStationStatus === "FAULT" ? (
                <p
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    cursor: "default",
                    background: "red",
                    border: "1px",
                    width: "180px",
                    color: "#fff",
                    borderRadius: "5px",
                    margin: "3px 0px 2px 2px",
                    padding: "3px 0px",
                  }}
                >
                  <span style={{ margin: "0px" }}>Fault</span>
                </p>
              ) : (
                <></>
              )}
              {/* {
                  row?.isActive ? (
                    <p style={{
                      display: "flex",
                      justifyContent: "center",
                      cursor: "default",
                      background: "#1A873C",
                      border: "1px",
                      width: "80px",
                      color: "#fff",
                      borderRadius: "5px",
                      margin: "3px 0px 2px 2px",
                      padding: "3px 0px",
                    }}>
                      <span style={{margin:"0px"}}>
                        Active
                      </span>
                    </p>
                  ) : (
                    <p style={{
                      display: "flex",
                      justifyContent: "center",
                      cursor: "default",
                      background: "#C71720",
                      border: "1px",
                      width : "80px",
                      color: "#fff",
                      borderRadius: "5px",
                      margin: "3px 0px 2px 2px",
                      padding: "3px 0px",
                    }}>
                      <span style={{margin:"0px"}}>
                        InActive
                      </span>
                    </p>
                  )
                } */}
            </>
          );
        },
      },
      {
        Header: "Action",
        accessor: "swapStationId",
        disableSortBy: true,
        Cell: (row) => {
          return (
            <>
              <div>
                <img
                  src={require("assets/eye.png").default}
                  style={{ margin: "8px", cursor: "pointer" }}
                  onClick={() =>
                    viewSwapStation(row.value, row.row.original.enterprise)
                  }
                ></img>
                <img
                  src={require("assets/pencil.png").default}
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    updateSwapStation(row.value, row.row.original.enterprise)
                  }
                ></img>
                <ConfirmationDialog
                  data={row.row.original}
                  handleStatus={(data) => {
                    statusActive(data);
                  }}
                  assets={"Swap Station"}
                  name={row.row.original.swapStationName}
                />
                {/* {row.row.original.isActive ? (
                  <button
                    onClick={() => siteStatusHandle(row, "active",row.row.original.enterpriseName)}
                    style={{ border: "none", margin: "8px" }}
                  >
                    <img src={require("assets/eye.png").default}></img>
                  </button>
                ) : (
                  <button
                    onClick={() => siteStatusHandle(row, "inactive",row.row.original.enterpriseName)}
                    style={{ border: "none", margin: "8px" }}
                  >
                    X
                  </button>
                )} */}
                {/* {row.row.original.isActive ? (
                  <button
                    onClick={() =>
                      siteStatusHandle(
                        row,
                        "active",
                        row.row.original.enterprise
                      )
                    }
                    style={{ border: "none", margin: "8px", cursor: "pointer" }}
                  >
                    <img
                      src={require("assets/active.png").default}
                      height={"20px"}
                      width={"20px"}
                    ></img>
                  </button>
                ) : (
                  <button
                    onClick={() =>
                      siteStatusHandle(
                        row,
                        "inactive",
                        row.row.original.enterprise
                      )
                    }
                    style={{ border: "none", margin: "8px", cursor: "pointer" }}
                  >
                    <img
                      src={require("assets/inactive.png").default}
                      height={"20px"}
                      width={"20px"}

                      // onClick={() =>
                      //   view(row.value, row.row.original.enterprise)
                      // }
                    ></img>
                  </button>
                )} */}
              </div>
            </>
          );
        },
      },
    ],
    [tempSwap, swapStationsData]
  );

  return (
    <div>
      <TableAndSearch
        totalCount={totalCount}
        activepageCount={activepageCount}
        paginationCountHanlde={paginationCountHanlde}
        searchOpts={{
          onSearch: getSwapStationsList,
          placeholder: "Search By Swap Station",
          setSearch: setSearch,
        }}
        columns={columns}
        data={swapStationsData}
        tigger={props?.tigger}
        tabTemp={props.tabTemp}
        tempSearch={tempSearch}
        headerFilterParms={headerFilter}
        isCheckBox={true}
        selectedData={deleteCheckBoxData}
      />
    </div>
  );
}

SwapStationList.inStorybook = true;
